import { useState, useCallback } from 'react'
import { TabNav } from '@/components/shared/TabNav.tsx'
import { ThemeToggle } from '@/components/shared/ThemeToggle.tsx'
import { DemoDatasetModal } from '@/components/demo/DemoDatasetModal.tsx'
import { SettingsModal } from '@/components/demo/SettingsModal.tsx'
import { useAppLock } from '@/components/AppLock/index.ts'
import { LockMenu } from '@/components/AppLock/LockMenu.tsx'
import { ShieldOff, Database, SettingsIcon } from 'lucide-react'
import { useAppStore } from '@/store/useAppStore.ts'

export function Header({ onOpenAbout }: { onOpenAbout: () => void }) {
  const { lock, isEnabled, enableEncryption } = useAppLock()
  const showLoadDemo = useAppStore((s) => s.showLoadDemo)
  const [demoOpen, setDemoOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)

  const openDemo = useCallback(() => setDemoOpen(true), [])
  const closeDemo = useCallback(() => setDemoOpen(false), [])
  const openSettings = useCallback(() => setSettingsOpen(true), [])
  const closeSettings = useCallback(() => setSettingsOpen(false), [])

  return (
    <>
      <header className="app-header">
        <div className="app-header__inner">
          <h1 className="header__title">Runtime Lens</h1>
          <TabNav />
          <div className="app-header__actions">
            {showLoadDemo && (
              <button
                type="button"
                onClick={openDemo}
                className="header__demo-btn"
                aria-label="Load demo dataset"
                title="Load Demo"
              >
                <Database size={18} />
                <span className="header__demo-label">Load Demo</span>
              </button>
            )}
            {isEnabled && lock ? (
              <LockMenu lock={lock} />
            ) : enableEncryption ? (
              <button onClick={enableEncryption} title="Enable password protection" aria-label="Enable password protection" className="header__lock-enable-btn">
                <ShieldOff size={18} />
              </button>
            ) : null}
            <button
              type="button"
              onClick={openSettings}
              className="header__settings-btn"
              aria-label="Settings"
              title="Settings"
            >
              <SettingsIcon size={18} />
            </button>
            <ThemeToggle />
          </div>
        </div>
      </header>
      <DemoDatasetModal isOpen={demoOpen} onClose={closeDemo} />
      <SettingsModal isOpen={settingsOpen} onClose={closeSettings} onOpenAbout={onOpenAbout} />
    </>
  )
}
